import { usePublishedData } from "../lib/published-data";
import { useShell } from "../lib/document-route";
import { createFileRoute, notFound, useLocation } from "@tanstack/react-router";
import contentStyles from "../styles/content.css?url";
import { ContentArticle } from "../components/content/content-article";
import { ReadLimit } from "../components/content/read-limit";
import { contentHead } from "../lib/content-head";
import { loadContentItem } from "../server/content";

/** A post (/blog/:slug): the whole post for a reader who may read it, its gate for anyone else. */
export const Route = createFileRoute("/blog/$slug")({
  loader: async ({ params }) => {
    const item = await loadContentItem({ data: { slug: params.slug, section: "blog" } });
    if (!item) throw notFound();
    return item;
  },
  head: ({ matches, loaderData, match }) =>
    contentHead(matches, loaderData, match.pathname, contentStyles),
  component: Post,
});

function Post() {
  const shell = useShell();
  const location = useLocation();
  const { data: item } = usePublishedData(Route.useLoaderData(), shell, location.pathname, "page");
  // A member reading faster than one account may gets a calm page instead of the post.
  if ("kind" in item)
    return <ReadLimit page={item} href={location.pathname + location.searchStr} />;
  // Each post starts fresh: a lesson's saved progress never carries over to the next one.
  return (
    <ContentArticle
      key={item.article.id}
      item={item}
      returnPath={location.pathname + location.searchStr}
      comments
      likes="live"
    />
  );
}
